import { IAddPaymentMethod, IPaymentMethods, SimpleAPIResponseFormat } from 'src/types'
import Paths from '../utils/paths'
import { serverApi } from '../utils/request'

class PaymentMethodsService {
  public async fetchPaymentMethods(serviceId: string): Promise<IPaymentMethods[] | null> {
    const result = await serverApi.get<SimpleAPIResponseFormat | null>(Paths.servicePaymentMethods.getManyByServiceId, {
      params: { serviceId }
    })
    return result.data && result.data.paymentMethods ? result.data.paymentMethods : []
  }
  public async updatePaymentMethods(
    serviceId: string,
    paymentMethods: IPaymentMethods[] | IAddPaymentMethod[]
  ): Promise<IPaymentMethods[] | null> {
    const result = await serverApi.put<SimpleAPIResponseFormat | null>(Paths.servicePaymentMethods.updateMany, {
      serviceId,
      paymentMethods
    })
    return result.data && result.data.paymentMethods ? result.data.paymentMethods : []
  }
  public async createPaymentMethod(paymentMethod: IAddPaymentMethod): Promise<IPaymentMethods[] | null> {
    const result = await serverApi.put<SimpleAPIResponseFormat | null>(
      Paths.servicePaymentMethods.create,
      paymentMethod
    )
    return result.data && result.data.paymentMethods ? result.data.paymentMethods : []
  }
}

const paymentMethodsService = new PaymentMethodsService()
export { paymentMethodsService }



// WEBPACK FOOTER //
// ./src/services/PaymentMethods.ts